import axios from "axios";
import { base_url } from "../../utils/baseUrl";
import { config } from "../../utils/axiosconfig";

const getToken = () => {
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;
  return user?.data?.token || null;
};

const getAuthHeaders = () => {
  const token = getToken();
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

const getPromotionalList = async () => {
  const response = await axios.get(`${base_url}promotype/all`, getAuthHeaders());

  return response.data;
};
const createPromotional = async (category) => {
  const response = await axios.post(`${base_url}promotype/add`, category, getAuthHeaders());

  return response.data;
};

const getPromotional = async (id) => {
  const response = await axios.get(`${base_url}promotype/get/${id}`, getAuthHeaders());

  return response.data;
};

const deletePromotionalList = async (id) => {
  const response = await axios.delete(`${base_url}promotype/delete/${id}`, getAuthHeaders());

  return response.data;
};
const updatePromotionalList = async (category) => {
  console.log(category);
  const response = await axios.put(
    `${base_url}promotype/edit/${category.id}`,
    { promotype_name: category.promoTypeData.promotype_name },
    getAuthHeaders()
  );

  return response.data;
};
const promotypeService = {
  getPromotionalList,
  createPromotional,
  getPromotional,
  deletePromotionalList,
  updatePromotionalList,
};

export default promotypeService;
